__webpack_require__.p = "https://assets.canny.io/70275d17479d9eab34659d70704190967ff6dd09/";